import { canAdministrate } from "./permissions"

export const RouteInfo = (path, ...permissions) => {
  return { path: path, permissions: permissions }
}

export const indexPage = RouteInfo("", canAdministrate)
export const ukmPage = RouteInfo("ukm", canAdministrate)
export const batchsPage = RouteInfo("batchs", canAdministrate)
export const cameraPage = RouteInfo("camera", canAdministrate)
export const ordersPage = RouteInfo("orders", canAdministrate)
export const reportsPage = RouteInfo("reports", canAdministrate)
export const aggregationsPage = RouteInfo("aggregations", canAdministrate)
export const profilePage = RouteInfo("profile", canAdministrate)
export const employeePage = RouteInfo("employee", canAdministrate)
export const registrationPage = RouteInfo("registration", canAdministrate)
export const linesPage = RouteInfo("lines", canAdministrate)
export const terminalsPage = RouteInfo("terminals", canAdministrate)
export const testingPage = RouteInfo("testing", canAdministrate)
export const productsPage = RouteInfo("products", canAdministrate)
export const documentsPage = RouteInfo("documents", canAdministrate)
